import React from "react";
import PropTypes from "prop-types";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";

// Components
import Modal from "../../components/Modal.js";
import InputText from "../../components/form/InputText.js";

// Style
import {breakpoint} from "../../style/components/breakpoints.js";
import {
  Button,
  Form,
  FormField,
  FormGroup,
  HeadingCenter,
  Inline,
  Text
} from "../../style/components/general.js";

const defaultValues = {
  name: ""
};

const schema = yup.object().shape({
  name: yup.string().required("Please provide checksheet name.")
});

const ModalCloneChecksheet = ({visible, setVisible, confirm, checksheetName}) => {
  const form = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema)
  });
  const {handleSubmit} = form;

  return (
    <Modal visible={visible} setVisible={setVisible} width={breakpoint.width[2]}>
      <HeadingCenter>Clone Checksheet</HeadingCenter>
      <FormProvider {...form}>
        <Form onSubmit={handleSubmit(confirm)} noValidate>
          <Text>
            Please provide a name for the new checksheet resulting from cloning {checksheetName}.
          </Text>
          <br />
          <FormGroup>
            <FormField>
              <InputText name="name" label="Name" autocomplete={false} />
            </FormField>
          </FormGroup>
          <Inline>
            <Button type="submit">Confirm</Button>
            <Button type="button" onClick={() => setVisible(false)}>
              Cancel
            </Button>
          </Inline>
        </Form>
      </FormProvider>
    </Modal>
  );
};

ModalCloneChecksheet.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  checksheetName: PropTypes.string.isRequired
};

export default ModalCloneChecksheet;
